import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  selector: 'app-info-panel',
  standalone: true,
  imports: [MatButtonModule, MatExpansionModule, MatIconModule, MatToolbarModule],
  templateUrl: './info-panel.component.html',
  styleUrl: './info-panel.component.css',
})
export class InfoPanelComponent {
  @ViewChild('closeBtn') private closeBtn?: ElementRef<HTMLButtonElement>;

  private _isOpen = false;

  @Input()
  set isOpen(value: boolean) {
    this._isOpen = value;
    if (value) {
      setTimeout(() => this.closeBtn?.nativeElement?.focus(), 225);
    }
  }
  get isOpen(): boolean {
    return this._isOpen;
  }

  @Input() title = '';

  @Output() closed = new EventEmitter<void>();

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this._isOpen) {
      this.closed.emit();
    }
  }

  onClose(): void {
    this.closed.emit();
  }
}
